import { createEvent } from "effector";

export const resetCollectionsTags = createEvent();
